import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46b979d9")

_pushScopeId("data-v-46b979d9")
const _hoisted_1 = { class: "lg:container lg:mx-auto pt-8" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-y-8 gap-x-0 lg:gap-x-8" }
const _hoisted_3 = { class: "col-span-2 mb-4" }
const _hoisted_4 = {
  key: 1,
  class: "px-4 lg:px-0 flex flex-col"
}
const _hoisted_5 = { class: "flex flex-wrap items-center -mt-2" }
const _hoisted_6 = { class: "pool-title" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = {
  key: 0,
  class: "font-medium text-gray-400 text-xs mt-px ml-1"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "hidden lg:block" }, null, -1)
const _hoisted_10 = { class: "col-span-2 order-2 lg:order-1" }
const _hoisted_11 = { class: "grid grid-cols-1 gap-y-8" }
const _hoisted_12 = { class: "mb-4 px-1 lg:px-0" }
const _hoisted_13 = { class: "order-1 lg:order-2 px-1 lg:px-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")
  const _component_BalAsset = _resolveComponent("BalAsset")
  const _component_FarmStatCardsLoading = _resolveComponent("FarmStatCardsLoading")
  const _component_FarmStatCards = _resolveComponent("FarmStatCards")
  const _component_FarmActionsCard = _resolveComponent("FarmActionsCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
              key: 0,
              class: "h-16"
            }))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.pool?.name), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.titleTokens, (token, i) => {
                  return (_openBlock(), _createBlock("div", {
                    key: i,
                    class: "mt-2 mr-2 flex items-center px-2 h-10 bg-gray-50 dark:bg-gray-850 rounded-lg"
                  }, [
                    _createVNode(_component_BalAsset, {
                      address: token.address,
                      size: 24
                    }, null, 8, ["address"]),
                    _createVNode("span", _hoisted_7, _toDisplayString(token.symbol), 1),
                    (!_ctx.isStableLikePool)
                      ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.fNum(token.weight, 'percent_lg')), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
      ]),
      _hoisted_9,
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_FarmStatCardsLoading, { key: 0 }))
              : (_openBlock(), _createBlock(_component_FarmStatCards, {
                  key: 1,
                  pool: _ctx.pool
                }, null, 8, ["pool"]))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
              key: 0,
              class: "h-96 sticky top-24"
            }))
          : (_openBlock(), _createBlock(_component_FarmActionsCard, {
              key: 1,
              pool: _ctx.pool,
              "missing-prices": _ctx.missingPrices,
              onOnTx: _ctx.onNewTx,
              class: "sticky top-24"
            }, null, 8, ["pool", "missing-prices", "onOnTx"]))
      ])
    ])
  ]))
})